/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createPickRandom } from '../../factoriesAny.js';
export var pickRandomDependencies = {
  typedDependencies,
  createPickRandom
};